///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { forEach, groupBy, sumBy, uniq } from "lodash";

import { round } from "./laneCalculations";
import messages from "./messages";

export const groupLoadsByShipper = loads => {
  const data = [];

  forEach(
    groupBy(loads, l => l.customerId),
    group => {
      return (
        group &&
        group.length &&
        data.push({
          loadIds: group.map(l => l.loadId),
          shipperName: group[0].customerName,
          volume: group.length,
          carriers: uniq(group.map(l => l.carrierId)).length,
          cost: round(sumBy(group, "cost") / group.length),
          cpm: round(sumBy(group, "cost") / sumBy(group, g => g.miles || 1)),
          distance: round(sumBy(group, g => g.miles) / group.length),
          margin: round(sumBy(group, "margin") / group.length),
          rate: round(sumBy(group, "rate") / group.length),
          metaData: { matched: true },
          exclude: messages.exclude.defaultMessage,
          carrierIds: group.map(l => l.carrierId)
        })
      );
    }
  );
  data.map((x, index) => (x.metaData.defaultIndex = index));
  return data;
};

export default groupLoadsByShipper;
